module.exports = __webpack_public_path__ + "static/media/companyDefaultIcon.374df6bc.svg";